import React from 'react'
import clsx from 'clsx'

type Props = React.ComponentProps<'div'>

export const Dots = ({ className, ...props }: Props) => (
  <div className={clsx('swiper-pagination', className)} {...props} />
)
